import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32930778")

_pushScopeId("data-v-32930778")
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_assign_product_group",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "modal-footer flex-center" }
const _hoisted_9 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_10 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_WmsViewOnlyNotice = _resolveComponent("WmsViewOnlyNotice")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.editProductGroupData,
          ref: "editProductGroupForm",
          disabled: _ctx.readOnly
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.ASSIGN')} ${_ctx.$t('message.PRODUCTS')}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                (_ctx.readOnly)
                  ? (_openBlock(), _createBlock(_component_WmsViewOnlyNotice, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_Select, {
                  name: "related_products",
                  target: "assignedProducts",
                  label: `${_ctx.$t('message.RELATED_PRODUCTS')}`,
                  multiple: true,
                  filterable: true,
                  placeholder: _ctx.$t('message.PRODUCTS'),
                  assignedProducts: _ctx.assignedProducts,
                  "onUpdate:assignedProducts": _cache[1] || (_cache[1] = ($event: any) => (_ctx.assignedProducts = $event)),
                  selectData: _ctx.products,
                  value: _ctx.assignedProducts
                }, null, 8, ["label", "placeholder", "assignedProducts", "selectData", "value"])
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              (!_ctx.readOnly)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-custom",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitHandlerForm()))
                  }, [
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ])
    ])
  ]))
})